import { Utils } from './utils'
import { deepClone, isEmptyArray, isNull, isNullObj, uniqueArray } from './validateBase'
import axios from 'axios'; // 引入axios
import { payDTO, CommonDTO } from '@/DTO/index'
import req from '@/utils/request';
const service = axios.create({
  baseURL: '', // 请求本地json文件，那么baseURL取空字符串，域名就会是项目域名
  // timeout: 1000,
  timeout: 30000,
});
// 定义医保结算请求的参数
let orderNumber = null;
let orderPayNumber = null;
let ybPrePayObj = {}
let insuTypeList = []
// 结算调用
export async function settlementCall(_this) {
  let { code } = await handlePrePay(_this) //先调用预支付保存预支付信息
  if (code == 200) {
    _this.settlementLoadingText = '结算中'
    let orderParams = {
      certno: _this.yibaoObj.baseinfo.certno, //证件号码
      psn_no: _this.yibaoObj.baseinfo.psn_no, //人员编号
      mdtrt_id: _this.request_2204Obj.request_2204[0].mdtrt_id, //就诊编号
      mdtrt_cert_type: _this.yibaoObj.mdtrt_cert_type, //就诊凭证类型
      mdtrt_cert_no: _this.yibaoObj.mdtrt_cert_no, //就诊凭证编号
      discount_amount: 0, //优惠金额
      sum_amount: _this.yibaoObj.price, //累计金额
      card_token: _this.yibaoObj.card_token, //校验介质
      insutype: _this.yibaoObj.insuinfoObj.insutype, //险种类型
      insuplc_admdvs: _this.yibaoObj.insuinfoObj.insuplc_admdvs, //就诊人员参保地医保区划
      orderPayNumber: orderPayNumber,
      wlt_acct_flag: _this.is_wlt_acct,//钱包账户使用标志	字符型	3		Y	0 不使用 1 使用
      minpacunt_drug_trac_cnt: _this.minpacuntDrugTracCnt
    }
    console.log(' 结算调用-------------------', orderParams)
    let param = {
      method: "post",
      url: `${_this.$shebaoUrl}/settlement`,
      data: orderParams,
      // timeout: 300,
    }
    var success = async function (res, resolve) {
      let price = deepClone(_this.yibaoObj.price)
      let obj = {
        orderNumber: orderNumber,
        orderPayNumber: orderPayNumber,
        request_2204Obj: _this.request_2204Obj,
        price: price,
        items: _this.yibaoObj.items,
        payWay: '1'
      }
      if (res.data.code == 200) {
        obj.paySuccess = '1'
        obj.attach = { ...handleSetlinfo(res.data.data.setlinfo, _this.yibaoObj.relation, _this.yibaoObj.insuinfoObj), detailList: _this.multipleSelection }
        console.log('订单结算接口调用成功 --- 医保支付！', res.data);
        let { fund_pay_sumamt, psn_cash_pay, acct_pay } = res.data.data.setlinfo
        // 处理划价支付参数
        _this.setlinfo = res.data.data.setlinfo
        _this.setldetail = res.data.data.setldetail
        _this.settlementLoadingText = '数据保存中'
        if (Utils.eq(psn_cash_pay, 0) && !isNull(psn_cash_pay)) {
          // 医保账户余额足够
          _this.$emit('yibaoPay', obj)
        } else {
          let time = await CommonDTO.getSystemTimeDTO()
          let yibaoPrice = _this.$bigNumber(fund_pay_sumamt, '+', acct_pay) //医保实际扣款
          _this.$message.success(`医保成功支付${yibaoPrice}元`)
          let callbackObj = {
            orderPayNumber: orderPayNumber, payTime: _this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
            paySuccess: '1', amount: yibaoPrice, attach: obj.attach
          }
          await payDTO.payCallback(callbackObj).then(callbackRes => {
            if (callbackRes.code == 200) {
              _this.dialogShow = false;
              _this.gjDialogShow = true;
            }
          })
        }
      } else {
        obj.paySuccess = '2'
        _this.$emit('yibaoPay', obj)
      }
      console.log('success end');
      resolve()
    }
    return new Promise((resolve, reject) => {
      axios(param).then(res => { success(res, resolve); }).catch(err => {
        let param = {
          orderNumber: orderNumber,
          orderPayNumber: orderPayNumber,
          request_2204Obj: _this.request_2204Obj,
          price: _this.yibaoObj.price,
          items: _this.yibaoObj.items,
          payWay: '1',
          paySuccess: '2'
        }
        _this.$message.error('医保错误或超时，请重试')
        _this.loading = false;
        _this.dialogShow = false;
        _this.settlementLoading = false;
        payDTO.payCallback(param).then(res => {
          //TODO  暂时无法处理 不清楚医保的超时时间
        })


      })
      console.log('结算调用完成');
    })
  }
}

//预支付
function handlePrePay(_this) {
  _this.settlementLoading = true;
  _this.settlementLoadingText = '保存记录'
  let preParams = {
    deptId: _this.$session.get('deptId'),
    ctOrderIds: _this.ctOrderIds,
    amount: _this.yibaoObj.price,
    payWay: '1',
    isMutualAidPay: false,//是否共济
  }
  preParams.attach = { ...handleSetlinfo(ybPrePayObj.setlinfo, _this.yibaoObj.relation, _this.yibaoObj.insuinfoObj), detailList: _this.multipleSelection }
  return new Promise((resolve, reject) => {
    payDTO.prePay(preParams).then(preRes => {
      _this.loadingText = '数据保存中'
      if (preRes.code == 200) {
        console.log('預支付調用成功', preRes);
        orderNumber = preRes.data.orderNumber;
        orderPayNumber = preRes.data.orderPayNumber;
        _this.orderNumber = orderNumber
        _this.orderPayNumber = orderPayNumber
        resolve({ code: 200 })
      } else {
        _this.loading = false;
        _this.dialogShow = false;
        _this.settlementLoading = false;
        resolve({ code: 500 })
      }
    }).catch(err => {
      _this.loading = false;
      _this.dialogShow = false;
      _this.settlementLoading = false;
      resolve({ code: 500 })
    })
  })

}

// 信息上传
function infoUpLoad(_this) {
  try {
    _this.loading = true
    _this.loadingText = '信息上传中'
    if (isNullObj(_this.yibaoObj)) {
      _this.$message('请重新刷卡')
      _this.cancel()
      _this.loading = false
      return;
    }
    let diagnosisList = deepClone(_this.diagnosisList)
    let diseinfos = []
    if (isEmptyArray(diagnosisList)) {
      diseinfos.push({
        diag_code: 'Z51.901',
        diag_name: '对症治疗',
        diag_dept: '中医科', // 诊断科室,
        dise_dor_no: _this.yibaoObj.doctorId, // 诊断医生编码
        dise_dor_name: _this.yibaoObj.doctorName, // 诊断医生姓名
        diag_time: _this.$timeRange.nowTimes, // 诊断时间 日期时间型 yyyy-MM-dd HH:mm:ss
      })
    } else {
      diagnosisList.forEach(item => {
        diseinfos.push({
          diag_code: isNull(item.diagnoseCode) ? 'Z51.901' : item.diagnoseCode,
          diag_name: isNull(item.diagnoseCode) ? '对症治疗' : item.diagnoseName,
          diag_dept: '中医科', // 诊断科室,
          dise_dor_no: _this.yibaoObj.doctorId, // 诊断医生编码
          dise_dor_name: _this.yibaoObj.doctorName, // 诊断医生姓名
          diag_time: _this.$timeRange.nowTimes, // 诊断时间 日期时间型 yyyy-MM-dd HH:mm:ss
        })
      })
    }
    diseinfos = uniqueArray(diseinfos, 'diag_code')
    // 信息上传参数
    let infoUploadParams = {
      certno: _this.yibaoObj.baseinfo.certno, // 身份证号码,
      psn_no: _this.yibaoObj.baseinfo.psn_no, //人员编号
      mdtrt_cert_type: _this.yibaoObj.mdtrt_cert_type, //就诊凭证类型
      mdtrt_cert_no: _this.yibaoObj.mdtrt_cert_no, //就诊凭证编号
      insutype: _this.yibaoObj.insuinfoObj.insutype, //险种类型
      card_token: _this.yibaoObj.card_token, //校验介质
      insuplc_admdvs: _this.yibaoObj.insuinfoObj.insuplc_admdvs, //就诊人员参保地医保区划
      request_2201: { // 挂号信息
        ipt_otp_no: (isNull(_this.yibaoObj.items) || isNull(_this.yibaoObj.items[0].rxno)) ? '' : _this.yibaoObj.items[0].rxno, // 住院/门诊号
        atddr_no: isNull(_this.yibaoObj.doctorCode) ? '' : _this.yibaoObj.doctorCode, // 医师编码
        dr_name: _this.yibaoObj.doctorName, // 医师姓名
        dept_code: 'ZYK', // 科室编码
        dept_name: '中医科', // 科室名称 
      },
      request_2203A: { // 诊断信息
        main_cond_dscr: _this.yibaoObj.diagnosis, // 主要病情描述
        begntime: _this.$timeRange.nowTimes, // 开始时间 yyyy-MM-dd HH:mm:ss
        diseinfos: diseinfos
      },
      request_2204: { // 费用明细
        fee_ocur_time: _this.$timeRange.nowTimes, // 支付时间
        bilg_dept_codg: '01', // 开单科室编码
        bilg_dept_name: '中医科', // 开单科室名称
        bilg_dr_codg: _this.yibaoObj.doctorId, // 开单医生编码
        bilg_dr_name: _this.yibaoObj.doctorName, // 开单医师姓名
        items: _this.ybPayWay == '1' && _this.yibaoObj.relation == '1' && !isEmptyArray(_this.tcRecipe) ? handleTcData(_this) : _this.multipleSelection, // 收费项目明细
      }
    }
    console.log('信息上次接口-------------------', infoUploadParams)

    let param = {
      method: "post",
      url: `${_this.$shebaoUrl}/upload_data`,
      data: infoUploadParams,
    }
    let axiosFun = function () {
      return new Promise((resolve, reject) => {
        axios(param).then(res => {
          resolve(res)
        }).catch(err => {
          _this.loading = false
        })
      })
    }
    let success = async function (res) {
      console.log('信息上传接口调用成功 --- 类似开方！', res.data);
      _this.yibaoStept = 2
      _this.request_2204Obj = res.data.data
      if (!isNull(res.data.data) && !isEmptyArray(res.data.data.request_2204[0])) {
        infoUploadParams.request_2204.items.forEach(v => {
          v.org_id = _this.$session.get('ybDeptNum')
          v.mdtrt_id = res.data.data.request_2204[0].mdtrt_id
        })
        req.post(`/chs/yb/createYb2204`, infoUploadParams.request_2204.items).then(async response => {
          if(response.code == 200){
            await preSettlement(res.data.data.request_2204[0].mdtrt_id, _this); // 预结算调用
          }else{
            _this.loading = false
          }
         })
      }
      console.log('settlementCall End');
    }
    let errorFun = function (err) {
      _this.loading = false
    }
    work(axiosFun, success, errorFun);

  } catch (error) {
    console.log(error);
    _this.loading = false
    CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
  }


}
// 退款
export async function cancelSettlement(preObj, payObj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      setl_id: payObj.attach.setlId, // 结算ID
      mdtrt_id: payObj.attach.mdtrtId, // 就诊ID
      psn_no: payObj.attach.psnNo, // 人员编号
      certno: payObj.attach.certno, // 身份证
      insuplc_admdvs: payObj.attach.insuplcAdmdvs //就诊人员参保地医保区划
    };
    preObj.attach = {}
    payDTO.preRefund(preObj).then(async preRes => {
      if (preRes.code == 200) {
        params.refundNumber = preRes.data.refundNumber
        // 退款
        let time = await CommonDTO.getSystemTimeDTO()
        let obj = {
          refundNumber: preRes.data.refundNumber,
          amount: preRes.data.preRefundAmount,
          refundTime: _this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
          reason: payObj.refundReason,
        }
        axios({
          method: "post",
          url: `${_this.$shebaoUrl}/repeal_settlement`,
          data: JSON.stringify(params),
        }).then(async res => {
          if (res.data.code == 200) {
            obj.refundStatus = '1'
            // console.log(handleRefundSetlinfo(res.data.data.setlinfo),2222222);
            obj.attach = handleRefundSetlinfo(res.data.data.setlinfo).setlinfoObj
            payDTO.refundCallback(obj).then(async refundRes => {
              if (refundRes.code == 200) {
                _this.$message.success('医保退款成功！')
                resolve()
              } else {
                _this.loading = false
                _this.$message.error('医保退费失败，请到退费管理重试')
                _this.$emit('updateData')
              }
            })
          } else {
            obj.refundStatus = '2'
            obj.attach = {}
            payDTO.refundCallback(obj).then(async refundRes => { })
            _this.loading = false
          }
        }).catch(err => {
          obj.refundStatus = '2'
          obj.attach = {}
          payDTO.refundCallback(obj).then(async refundRes => { })
          _this.loading = false
          _this.$message.error('医保退费失败，请到退费管理重试')
          _this.$emit('updateData')
        })
      } else {
        _this.loading = false
      }
    })
  })

}


let work = Utils.jugeYBExecute();

// 医保初始化
export function initYB(_this) {
  _this.yibaoObj = {}
  // _this.loading = true
  _this.loadingText = '查询人员信息'
  let param = {
    method: "post",
    url: `${this.$shebaoUrl}/query_person_info`,
  }
  axios(param).then(async res => {
    if (res.data.code == 200) {
      _this.yibaoStept = 1;
      let data = JSON.parse(JSON.stringify(res.data.data));
      //查询统计信息
      _this.cumObj = await queryCheckAccountTotal(data, _this)
      //人员慢特病备案查询
      queryDisease(data, _this).then(diseaseRes => {
        if (diseaseRes.code == 200) {
          let diseaseList = []
          diseaseRes.data && diseaseRes.data.forEach(v => {
            diseaseList.push(v.opsp_dise_name)
          })
          _this.disease = diseaseList.join(',')
        }
      })
      let insuinfoList = []
      CommonDTO.getDictOptions('psn_type').then(json1 => { // 获取医保类别json文件
        // 处理医保类别回显
        data.insuinfo.forEach(obj1 => {
          json1.forEach(item1 => {
            if (item1.code_value == obj1.psn_type) obj1.psn_typeStr = item1.code_name;
          });
        })
        CommonDTO.getDictOptions('insutype').then(json2 => { // 获取保险类型json文件
          insuTypeList = json2;
          data.insuinfo.forEach(item => {
            json2.forEach(obj => {
              if (item.insutype == obj.code_value) {
                insuinfoList.push({
                  ...item,
                  label: obj.code_name
                })

              }
            })
          })
          data.insuinfo = insutypeSort(insuinfoList)
          _this.yibaoObj = {
            ...data,
            doctorId: _this.doctorInfo.doctorId,
            doctorName: _this.doctorInfo.doctorName,
            doctorCode: isNull(_this.doctorInfo.doctorCode) ? '' : _this.doctorInfo.doctorCode,
            diagnosis: _this.diagnosis || '对症治疗',
          };
          if (_this.patientInfo.patientName != data.baseinfo.psn_name) {
            _this.$message.error(`当前持卡人为${data.baseinfo.psn_name},仅允许使用患者本人的医保卡`);
            this.loading = false;
            _this.cancel()
            return;
          }
          _this.yibaoObj.relation = '1'
          _this.yibaoObj.items = handleItems(_this)
          _this.$forceUpdate()
          _this.$nextTick(() => {
            _this.yibaoObj.items.forEach(item => {
              _this.$refs.multipleTable.$refs.customTable.toggleRowSelection(item);
            })
            _this.$refs['yibaoDialogRef-input'].focus();
            _this.yibaoBtn = false
            _this.loading = false
          })
          _this.insuinfoList = data.insuinfo
          _this.insutype = data.insuinfo[0].insutype
          _this.yibaoObj.insuinfoObj = data.insuinfo[0]
          _this.insuranceDialogShow = true
        });

      });

    } else {
      _this.loading = false
      _this.cancel()
    }
  }).catch(err => {
    _this.loading = false
  })
}
// 处理收费项目明细（个账）
export function handleItems(_this) {
  try {
    let items = [],
      total = 0;
    _this.recipesList.forEach(item => {
      if (!isNull(item.processFlag) && item.processFlag == '1' && !isNullObj(item.process)) {
        if (item.isYlcp == '1') {
          items.push({
            feedetl_sn: item.paymentOrderNum,
            med_list_codg: '004800000030000-480000009',
            medins_list_codg: isNull(item.process.processArtNo) ? '' : item.process.processArtNo,
            det_item_fee_sumamt: isNull(item.process.bargainProcessPrice) ? 0 : _this.$bigNumber(item.process.bargainProcessPrice, '*', item.doseNum, 2),
            pric: isNull(item.process.bargainProcessPrice) ? 0 : item.process.bargainProcessPrice,
            cnt: item.doseNum,
            rxno: item.paymentOrderNum,
            unit: '次',
            itemName: item.process.processName,
            paymentRecipeId: item.paymentRecipeId,
            hosp_appr_flag: '2',
            itemNum: 1,
            medicalInsuranceType: '3',
          });
        } else {
          items.push({
            feedetl_sn: item.paymentOrderNum,
            med_list_codg: '004800000030000-480000009',
            medins_list_codg: isNull(item.process.processArtNo) ? '' : item.process.processArtNo,
            det_item_fee_sumamt: isNull(item.process.bargainProcessPrice) ? 0 : item.process.bargainProcessPrice,
            pric: isNull(item.process.bargainProcessPrice) ? 0 : item.process.bargainProcessPrice,
            cnt: 1,
            rxno: item.paymentOrderNum,
            unit: '次',
            itemName: '加工费',
            paymentRecipeId: item.paymentRecipeId,
            hosp_appr_flag: '2',
            itemNum: 1,
            medicalInsuranceType: '3'
          });
        }

      }
      if (!isNull(item.items)) {
        item.items.forEach(item0 => {
          // 有医保编码、药品属性设置为可统筹或仅个账才能刷医保
          if ((!isNull(item0.dictDrugCode) && item.recipeType != '3' && !isNull(item0.medicalInsuranceType) && (item0.medicalInsuranceType == '2' || item0.medicalInsuranceType == '3')) || (!isNull(item0.dictDrugCode) && item.recipeType == '3')) {
            let { artNo, dictDrugCode, itemNum, itemUnit, itemName, bargainTotalPrice, bargainPrice, medicalInsuranceType, min_pac_cnt, min_pacunt } = item0;
            let newNumer = _this.$bigNumber(itemNum, '*', isNull(item.doseNum) ? 1 : item.doseNum)
            let isgt = Utils.gt(bargainTotalPrice, 0)
            if (isgt && item0.isOwned != '1') {
              items.push({
                feedetl_sn: item.paymentOrderNum,
                med_list_codg: dictDrugCode,
                medins_list_codg: artNo,
                det_item_fee_sumamt: bargainTotalPrice, //折后总价
                pric: bargainPrice, //单价
                cnt: newNumer, //数量
                rxno: item.paymentOrderNum,
                unit: itemUnit,
                itemName: itemName,
                paymentRecipeId: item0.paymentRecipeId,
                itemNum: itemNum,
                recipeType: item.recipeType,
                medicalInsuranceType: item.recipeType == '3' ? '2' : medicalInsuranceType,
                hosp_appr_flag: (_this.ybPayWay == '1' && item.recipeType == '3') || (_this.ybPayWay == '1' && item0.medicalInsuranceType == '2' && !isEmptyArray(_this.tcRecipe)) ? '1' : '2',
                min_pac_cnt: min_pac_cnt,
                min_pacunt: min_pacunt,
              });
              total = _this.$bigNumber(total, '+', bargainTotalPrice);
            }
          }
        })
      }
    })
    items.forEach((v, i) => {
      v.feedetl_sn = `${v.feedetl_sn}${i}`
    })
    _this.yibaoObj.price = total;
    console.log(items, 2222);
    return items;
  } catch (error) {
    CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
  }

}
//处理可统筹数据
function handleTcData(_this) {
  try {
    let arr = [];
    _this.multipleSelection.forEach(obj => {
      let item = _this.recipesList.find(item => { return item.paymentRecipeId == obj.paymentRecipeId })
      if (item.recipeType == '3') {
        //理疗都可统筹
        arr.push({
          ...obj,
          hosp_appr_flag: '1'
        })
      } else {
        if (isNull(item.tcDoseNum) || obj.itemName == '加工费' || obj.medicalInsuranceType == '3') {
          arr.push({
            ...obj,
            hosp_appr_flag: '2'
          })
        } else {
          let tcNumber = _this.$bigNumber(item.tcDoseNum, '*', obj.itemNum)
          let gzNumer = _this.$bigNumber((item.doseNum - item.tcDoseNum), '*', obj.itemNum)
          arr.push({
            ...obj,
            cnt: tcNumber,
            det_item_fee_sumamt: _this.$bigNumber(obj.pric, '*', tcNumber, 2),
            hosp_appr_flag: obj.medicalInsuranceType == '2' ? '1' : '2'
          })
          if (gzNumer > 0) {
            arr.push({
              ...obj,
              cnt: gzNumer,
              det_item_fee_sumamt: _this.$bigNumber(obj.det_item_fee_sumamt, '-', _this.$bigNumber(obj.pric, '*', tcNumber, 2)),
              hosp_appr_flag: '2',
              pric: _this.$bigNumber(_this.$bigNumber(obj.det_item_fee_sumamt, '-', _this.$bigNumber(obj.pric, '*', tcNumber, 2)), '/', gzNumer, 4)
            })
          }
        }
      }
    })
    arr.forEach((v, i) => {
      v.feedetl_sn = `${v.rxno}${i}`
    })
    console.log(arr, 787877887);
    return arr;
  } catch (error) {
    CommonDTO.saveLogDTO({ businessType: '1', errorMsg: error.message })
  }
}

// 医保结算
export function settlement(_this) {
  // 信息上传接口调用
  infoUpLoad(_this);
}

//预结算
function preSettlement(mdtrt_id, _this) {
  _this.loadingText = '预结算中'
  let preParams = {
    deptId: _this.$session.get('deptId'),
    ctOrderIds: _this.ctOrderIds,
    amount: _this.yibaoObj.price,
    payWay: '1',
  }
  let preOrderParams = {
    certno: _this.yibaoObj.baseinfo.certno, //证件号码
    psn_no: _this.yibaoObj.baseinfo.psn_no, //人员编号
    mdtrt_id: mdtrt_id, //就诊编号
    mdtrt_cert_type: _this.yibaoObj.mdtrt_cert_type, //就诊凭证类型
    mdtrt_cert_no: _this.yibaoObj.mdtrt_cert_no, //就诊凭证编号
    discount_amount: 0, //优惠金额
    sum_amount: _this.yibaoObj.price, //累计金额
    card_token: _this.yibaoObj.card_token, //校验介质
    insutype: _this.yibaoObj.insuinfoObj.insutype, //险种类型
    insuplc_admdvs: _this.yibaoObj.insuinfoObj.insuplc_admdvs, //就诊人员参保地医保区划
    wlt_acct_flag: _this.is_wlt_acct, //钱包账户使用标志	字符型	3		Y	0 不使用 1 使用
  }
  console.log(' 预结算调用-------------------', preOrderParams)
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/prepare_settlement`,
    data: preOrderParams,
  }
  var success = function (res) {
    if (res.data.code == 200) {
      ybPrePayObj = res.data.data
      _this.setlinfo = { ...res.data.data.setlinfo }
      _this.dialogShow = true
      _this.loading = false;
    } else {
      _this.loading = false;
    }
  }

  axios(param).then(res => {
    console.log('预结算调用完成');
    success(res);
  }).catch(err => {
    console.log('error end');
    console.log(err);
    _this.loading = false
  })
}

//查询共济关系

export function getGjRelation(_this, obj) {
  _this.gjLoadingText = '查询共济关系'
  _this.gjRelation = ''
  let paramsData = {
    psn_no: _this.yibaoObj.baseinfo.psn_no, //就医人员个人编号
    certno: obj.baseinfo.certno, //共济人证件号码
    type: 1, //绑定类型 	此处默认为1：绑定人
    insuplc_admdvs: obj.insuplc_admdvs, //员工投保区划
  }
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/query_gj_relation`,
    data: paramsData
  }
  let success = function (res, resolve) {
    if (res.data.code == 200) {
      if (!isNull(res.data.data)) {
        _this.relationDialogShow = true
        _this.gjRelation = isEmptyArray(res.data.data.result) ? '' : res.data.data.result[0].hser_rlts
      }
    } else {
      // 失败后反向再查一次
      let paramsData2 = {
        psn_no: obj.baseinfo.psn_no,
        certno: _this.yibaoObj.baseinfo.certno, //共济人证件号码
        type: 1, //绑定类型 	此处默认为1：绑定人
        insuplc_admdvs: _this.yibaoObj.insuplc_admdvs, //员工投保区划
      }
      let param2 = {
        method: "post",
        url: `${_this.$shebaoUrl}/query_gj_relation`,
        data: paramsData2
      }
      axios(param2).then(res2 => {
        _this.relationDialogShow = true
        if (res2.data.code == 200) {
          if (!isNull(res2.data.data)) {
            let relation = isEmptyArray(res2.data.data.result) ? '' : res2.data.data.result[0].hser_rlts
            if (relation == '1') {
              _this.gjRelation = '3'
            } else if (relation == '3') {
              _this.gjRelation = '1'
            } else {
              _this.gjRelation = relation
            }
          }
        } else {
          _this.gjDialogShow = true;
          _this.gjLoading = false;
        }
      })
    }
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => { success(res, resolve) }).catch(() => {
      _this.gjDialogShow = true;
      _this.gjLoading = false;
    })
  })
}

//共济下账  预下账和下账
export function gjSettlement(_this) {
  _this.loading = true
  _this.loadingText = '共济预结算中'
  //1.先调用医保共济预下账
  //2.调用共济预支付
  //3.调用共济下账
  //4.调用支付
  let params = {
    psn_no: _this.kinsfolkObj.baseinfo.psn_no, //人员编号 
    mdtrt_cert_type: _this.kinsfolkObj.mdtrt_cert_type, //就诊凭证类型
    mdtrt_cert_no: _this.kinsfolkObj.mdtrt_cert_no, //就诊凭证编号
    insutype: _this.insutype, //险种
    acct_mulaid_pay: _this.setlinfo.psn_cash_pay, //个人账户共济支付金额
    ima_mdtrt_id: _this.setlinfo.mdtrt_id, //原主交易就诊ID 字符型	30	　	Y
    ima_setl_id: _this.setlinfo.setl_id, //原主交易结算ID 字符型	30		Y
    ima_certno: _this.setlinfo.certno, //原主交易证件号码 字符型	50		Y
    ima_med_type: _this.setlinfo.med_type, //原主交易医疗类别 字符型	6	Y Y   同med_type
    ima_medfee_sumamt: _this.setlinfo.medfee_sumamt, //原主交易医疗费总额 数值型	16,2		Y
    ima_fund_pay_sumamt: _this.setlinfo.fund_pay_sumamt, //原主交易基金支付总额 数值型	16,2	　	Y
    ima_acct_pay: _this.setlinfo.acct_pay, //原主交易个人账户支出 数值型	16,2	　	Y
    ima_psn_cash_pay: _this.setlinfo.psn_cash_pay, //原主交易个人现金支出 数值型	16,2	　	Y
    ima_psn_no: _this.setlinfo.psn_no, //原主交易个人编号 字符型	30		Y
    ima_psn_name: _this.setlinfo.psn_name, //原主交易人员姓名 字符型	50		Y
    relation: _this.gjRelation, //亲属关系 字符型	6	Y Y   与原主交易人员关系 【1:父母,2:配偶,3:子女】
    set_flag: '00', //结算标志 字符型	6	Y Y   预结正结标志 00	预结算	11	正式结算
    insuplc_admdvs: _this.kinsfolkObj.insuplc_admdvs,
    expContent: {
      card_token: _this.kinsfolkObj.card_token
    }
  }
  let preObj = {
    deptId: _this.$session.get('deptId'),
    ctOrderIds: _this.ctOrderIds,
    amount: _this.setlinfo.psn_cash_pay,
    payWay: '1',
    isMutualAidPay: true,//是否共济
  }
  let postParams = {
    method: "post",
    url: `${_this.$shebaoUrl}/gj_settlement`,
    data: params,
  }
  let success = async function (res, resolve) {
    // 2.预下账成功后调用共济预支付
    if (res.data.code === 200) {
      _this.loadingText = '数据保存中'
      preObj.attach = { ...handleSetlinfo(res.data.data.result, _this.gjRelation, _this.yibaoObj.gjInsuinfoObj), }
      let preRes = await payDTO.prePay(preObj)
      if (preRes.code === 200) {
        _this.loadingText = '共济结算中'
        params.orderPayNumber = preRes.data.orderPayNumber
        // 3.调用共济下账
        params.set_flag = '11'
        axios(postParams).then(gjRes => {
          let obj = {
            orderNumber: preRes.data.orderNumber,
            orderPayNumber: preRes.data.orderPayNumber,
            price: res.data.data.result.acct_pay,
            items: _this.yibaoObj.items,
            paySuccess: '1',
            payWay: '1'
          }
          if (gjRes.data.code === 200) {
            _this.gjSetlinfo = gjRes.data.data.result
            obj.attach = { ...handleSetlinfo(gjRes.data.data.result, _this.gjRelation, _this.yibaoObj.gjInsuinfoObj), }
            _this.$emit('yibaoPay', obj)
          } else {
            obj.paySuccess = '2'
            _this.$emit('yibaoPay', obj)
          }
        })
      } else {
        _this.gjDialogShow = true;
      }
    } else {
      _this.loading = false
      _this.loadingText = ''
      _this.gjLoading = false;
      _this.gjDialogShow = true;
    }
  }
  return new Promise((resolve, reject) => {
    //1.医保共济预下账
    axios(postParams).then(res => { success(res, resolve) })
  })
}

//查询人员信息
export function personInfo(_this) {
  _this.kinsfolkObj = {}
  _this.insuinfoList = []
  _this.insutype = ''
  _this.gjLoading = true
  _this.gjLoadingText = '查询亲属信息'
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/person_info`,
    data: { tran_no: 'S2101' }
  }
  let success = function (res, resolve) {
    if (res.data.code == 200) {
      let insuinfoList = []
      _this.kinsfolkObj = res.data.data
      _this.kinsfolkObj.insuinfo.forEach(item => {
        insuTypeList.forEach(obj => {
          if (item.insutype == obj.code_value) {
            insuinfoList.push({
              ...item,
              label: obj.code_name
            })

          }
        })
      })
      _this.insuinfoList = insutypeSort(insuinfoList)
      _this.insutype = _this.insuinfoList[0].insutype
      getGjRelation(_this, res.data.data)
      // _this.relationDialogShow = true
    } else {
      _this.gjLoading = false
    }
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => { success(res, resolve) })
  })
}

//对险种类型进行排序
function insutypeSort(list) {
  if (isEmptyArray(list) || isNull(list)) return [];
  const sortOrder = ['310', '390', '340'];
  list.sort((a, b) => {
    const indexA = sortOrder.indexOf(a.insutype);
    const indexB = sortOrder.indexOf(b.insutype);
    // 如果 a 或 b 不在排序规则中，返回一个较大的值使其排在后面
    if (indexA === -1 && indexB === -1) {
      return 0; // 两者都不在排序规则中，保持原顺序
    } else if (indexA === -1) {
      return 1; // a 不在排序规则中，b 在排序规则中，a 排在后面
    } else if (indexB === -1) {
      return -1; // b 不在排序规则中，a 在排序规则中，b 排在后面
    } else {
      return indexA - indexB; // 两者都在排序规则中，按规则排序
    }
  })
  return list;
}


//处理医保明细字段
export function handleSetlinfo(setlinfo, relation, insuinfo) {
  let { emp_name, insuplc_admdvs } = insuinfo
  let {
    mdtrt_id,
    setl_id,
    psn_no,
    psn_name,
    psn_cert_type,
    certno,
    gend,
    naty,
    brdy,
    age,
    insutype,
    psn_type,
    cvlserv_flag,
    setl_time,
    mdtrt_cert_type,
    med_type,
    medfee_sumamt,
    fulamt_ownpay_amt,
    overlmt_selfpay,
    preselfpay_amt,
    inscp_scp_amt,
    act_pay_dedc,
    hifp_pay,
    pool_prop_selfpay,
    cvlserv_pay,
    hifes_pay,
    hifmi_pay,
    hifob_pay,
    maf_pay,
    oth_pay,
    fund_pay_sumamt,
    psn_part_amt,
    acct_pay,
    psn_cash_pay,
    hosp_part_amt,
    balc,
    acct_mulaid_pay,
    medins_setl_id,
    clr_optins,
    clr_way,
    clr_type,
    exp_content
  } = setlinfo;
  let attach = {
    mdtrtId: mdtrt_id || '',
    setlId: setl_id || '',
    psnNo: psn_no || '',
    psnName: psn_name || '',
    psnCertType: psn_cert_type || '',
    certno: certno || '',
    gend: gend || '',
    naty: naty || '',
    brdy: brdy || '',
    age: age || '',
    insutype: insutype || '',
    psnType: psn_type || '',
    cvlservFlag: cvlserv_flag || '',
    setlTime: setl_time || '',
    mdtrtCertType: mdtrt_cert_type || '',
    medType: med_type || '',
    medfeeSumamt: medfee_sumamt || '',
    fulamtOwnpayAmt: fulamt_ownpay_amt || '',
    overlmtSelfpay: overlmt_selfpay || '',
    preselfpayAmt: preselfpay_amt || '',
    inscpScpAmt: inscp_scp_amt || '',
    actPayDedc: act_pay_dedc || '',
    hifpPay: hifp_pay || '',
    poolPropSelfpay: pool_prop_selfpay || '',
    cvlservPay: cvlserv_pay || '',
    hifesPay: hifes_pay || '',
    hifmiPay: hifmi_pay || '',
    hifobPay: hifob_pay || '',
    mafPay: maf_pay || '',
    othPay: oth_pay || '',
    fundPaySumamt: fund_pay_sumamt || '',
    psnPartAmt: psn_part_amt || '',
    acctPay: acct_pay || '',
    psnCashPay: psn_cash_pay || '',
    hospPartAmt: hosp_part_amt || '',
    balc: balc || '',
    acctMulaidPay: acct_mulaid_pay || '',
    relation: relation || '',
    medinsSetlId: medins_setl_id || '',
    clrOptins: clr_optins || '',
    clrWay: clr_way || '',
    clrType: clr_type || '',
    empName: isNull(emp_name) ? '' : emp_name,
    insuplcAdmdvs: isNull(insuplc_admdvs) ? '' : insuplc_admdvs,
    wltpayAmt: exp_content && exp_content.wltpay_amt || ''
  }
  return attach;
}

//处理退款明细字段
export function handleRefundSetlinfo(setlinfo, setldetail) {
  let {
    acct_mulaid_pay,
    acct_pay,
    act_pay_dedc,
    balc,
    clr_optins,
    cvlserv_pay,
    fulamt_ownpay_amt,
    fund_pay_sumamt,
    hifes_pay,
    hifmi_pay,
    hifob_pay,
    hifp_pay,
    hosp_part_amt,
    inscp_scp_amt,
    maf_pay,
    mdtrt_id,
    medfee_sumamt,
    medins_setl_id,
    oth_pay,
    overlmt_selfpay,
    pdn_cash_pay,
    pool_prop_selfpay,
    preselfpay_amt,
    psn_part_amt,
    setl_id,
    setl_time
  } = setlinfo
  // let setldetailArr = []
  // setldetail.forEach(item => {
  //     let { crt_payb_lmt_amt, fund_pay_type, fund_pay_type_name, fund_payamt, setl_proc_info } = item
  //     setldetailArr.push({
  //         crtPaybLmtAmt: crt_payb_lmt_amt,
  //         fundPayType: fund_pay_type,
  //         fundPayTypeName: fund_pay_type_name,
  //         fundPayamt: fund_payamt,
  //         setlProcInfo: setl_proc_info,
  //         inscpScpAmt: item.inscp_scp_amt,
  //     })
  // })

  let setlinfoObj = {
    acctMulaidPay: acct_mulaid_pay || '',
    acctPay: acct_pay || '',
    actPayDedc: act_pay_dedc || '',
    balc: balc || '',
    clrOptins: clr_optins || '',
    cvlservPay: cvlserv_pay || '',
    fulamtOwnpayAmt: fulamt_ownpay_amt || '',
    fundPaySumamt: fund_pay_sumamt || '',
    hifesPay: hifes_pay || '',
    hifmiPay: hifmi_pay || '',
    hifobPay: hifob_pay || '',
    hifpPay: hifp_pay || '',
    hospPartAmt: hosp_part_amt || '',
    inscpScpAmt: inscp_scp_amt || '',
    mafPay: maf_pay || '',
    mdtrtId: mdtrt_id || '',
    medfeeSumamt: medfee_sumamt || '',
    medinsSetlId: medins_setl_id || '',
    othPay: oth_pay || '',
    overlmtSelfpay: overlmt_selfpay || '',
    pdnCashPay: pdn_cash_pay || '',
    poolPropSelfpay: pool_prop_selfpay || '',
    preselfpayAmt: preselfpay_amt || '',
    psnPartAmt: psn_part_amt || '',
    setlId: setl_id || '',
    setlTime: setl_time || '',
  }
  return { setlinfoObj }
}

// 根据结算信息查询详细结算信息
export function querySettlementInfo(obj, _this) {
  let data = {
    mdtrt_id: obj.mdtrtId, //就诊id
    setl_id: obj.setlId, //结算id
    psn_no: obj.psnNo, //人员编号
    insuplc_admdvs: obj.insuplcAdmds
  }
  let param = {
    method: "post",
    url: `${_this.$shebaoUrl}/query_settlement_info`,
    data,
  }
  let success = function (res, resolve) {
    resolve(res.data)
  }
  let errorFun = function (err, reject) {
    reject(err)
  }
  return new Promise((resolve, reject) => {
    axios(param).then(res => { success(res, resolve) }).catch(err => { errorFun(err, reject) })
  })
}

//重试医保退款
export function ybCancelSettlement(obj, _this) {
  return new Promise((resolve, reject) => {
    let { setlId, mdtrtId, psnNo, certno, insuplcAdmds, refundNumber } = obj
    let params = {
      setl_id: setlId, // 结算ID
      mdtrt_id: mdtrtId, // 就诊ID
      psn_no: psnNo, // 人员编号
      certno: certno, // 身份证
      insuplc_admdvs: insuplcAdmds, //就诊人员参保地医保区划
      refundNumber
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/repeal_settlement`,
      data: JSON.stringify(params),
    }).then(async res => {
      resolve(res.data)
    }).catch(err => {
      res.data.code == 500
      resolve(res.data)
    })
  })

}

//查询统计信息
export function queryCheckAccountTotal(obj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      psn_no: obj.baseinfo && obj.baseinfo.psn_no || '', // 人员编号
      insuplc_admdvs: obj.insuplc_admdvs, //就诊人员参保地医保区划
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/query_cum`,
      data: JSON.stringify(params),
    }).then(async res => {
      if (res.data.code == 200) {
        resolve(res.data.data)
      } else {
        resolve(null)
      }
    }).catch(err => {
      resolve(null)
    })
  })
}
//人员慢特病备案查询
export function queryDisease(obj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      psn_no: obj.baseinfo && obj.baseinfo.psn_no || '', // 人员编号
      insuplc_admdvs: obj.insuplc_admdvs, //就诊人员参保地医保区划
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/query_disease`,
      data: JSON.stringify(params),
    }).then(async res => {
      resolve(res.data)
    }).catch(err => {
      res.data.code == 500
      resolve(res.data)
    })
  })
}

//共济退款
export async function gjCancelSettlement(preObj, payObj, _this) {
  return new Promise((resolve, reject) => {
    let params = {
      setl_id: payObj.attach.setlId, // 结算ID
      mdtrt_id: payObj.attach.mdtrtId, // 就诊ID
      psn_no: payObj.attach.psnNo, // 人员编号
      insuplc_admdvs: payObj.attach.insuplcAdmdvs
    };
    preObj.attach = {}
    payDTO.preRefund(preObj).then(async preRes => {
      if (preRes.code == 200) {
        params.refundNumber = preRes.data.refundNumber
        // 退款
        let time = await CommonDTO.getSystemTimeDTO()
        let obj = {
          refundNumber: preRes.data.refundNumber,
          amount: preRes.data.preRefundAmount,
          refundTime: _this.$moment(time).format('YYYY-MM-DD HH:mm:ss'),
          reason: payObj.refundReason,
        }
        axios({
          method: "post",
          url: `${_this.$shebaoUrl}/gj_repeal_settlement`,
          data: JSON.stringify(params),
        }).then(async res => {
          if (res.data.code == 200) {
            obj.refundStatus = '1'
            obj.attach = handleRefundSetlinfo(res.data.data.result).setlinfoObj
            payDTO.refundCallback(obj).then(async refundRes => {
              if (refundRes.code == 200) {
                _this.$message.success('医保共济退款成功！')
                resolve()
              } else {
                _this.loading = false
                _this.$message.error('医保退费失败，请到退费管理重试')
                _this.$emit('updateData')
              }
            })
          } else {
            obj.refundStatus = '2'
            obj.attach = {}
            payDTO.refundCallback(obj).then(async refundRes => { })
            _this.loading = false
          }
        }).catch(err => {
          obj.refundStatus = '2'
          obj.attach = {}
          payDTO.refundCallback(obj).then(async refundRes => { })
          _this.loading = false
          _this.$message.error('医保退费失败，请到退费管理重试')
          _this.$emit('updateData')
        })
      } else {
        _this.loading = false
      }
    })
  })

}
//重试共济退款
export function ybGjCancelSettlement(obj, _this) {
  return new Promise((resolve, reject) => {
    let { setlId, mdtrtId, psnNo, refundNumber, insuplcAdmds } = obj
    let params = {
      setl_id: setlId, // 结算ID
      mdtrt_id: mdtrtId, // 就诊ID
      psn_no: psnNo, // 人员编号
      refundNumber,
      insuplc_admdvs: insuplcAdmds
    };
    axios({
      method: "post",
      url: `${_this.$shebaoUrl}/gj_repeal_settlement`,
      data: JSON.stringify(params),
    }).then(async res => {
      resolve(res.data)
    }).catch(err => {
      res.data.code == 500
      resolve(res.data)
    })
  })

}